import React from 'react';
import { useAppSelector } from "src/store/hooks";
import { selectCategoryById } from "src/store/community/categoriesSlice";
import { selectAssetById } from "src/store/community/assetsSlice";

import { RightSidebar } from "src/pages/_partials/Layout";
import { EntityId } from "@reduxjs/toolkit";
import Meta from "src/componets/Meta";

const _SidebarShow = ({ id }: { id: EntityId | undefined }) => {
  const asset = useAppSelector(state => id ? selectAssetById(state, id) : undefined);
  const category = useAppSelector(state => asset?.category_id ? selectCategoryById(state, asset?.category_id) : undefined);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {category && <h6 className="v-content-label o-sm">Category</h6>}
      {category && <Meta title={category.name} avatar={category.thumbnail_url} />}
    </RightSidebar>
  )
}

export default _SidebarShow;
